module.exports = __webpack_public_path__ + "static/media/prism-logo.6ecc7d84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/prism-logo.png
// module id = 905
// module chunks = 0